export default "assets/images/texture_yellow-e5611287.jpg";